<template>
  <div>
    <div
      v-if="isVisible"
      class="jProgressScreen">
      <div
        id="progress-screen"
        class="notification-screen">
        <div class="floating-container">
          <span>
            <i class="fa fa-check-circle"/>
          </span>
          <h1 id="progress-screen-data">Processing {{ retrievedData.length }}/{{ max }}</h1>
          <b-progress
            :max="max"
            class="mb-3">
            <b-progress-bar
              :value="numOfFailed"
              variant="danger"/>
            <b-progress-bar
              :value="numOfSuccess"
              variant="success"/>
          </b-progress>
          <div id="progress-screen-message">
            <span class="span__success--green">{{ numOfSuccess }} data success</span>
            <br>
            <span class="span_failed--red">{{ numOfFailed }} data failed</span>
            <div
              v-if="getErrorDatas.length > 0"
              id="progress-message-container">
              <p>Problem Message:</p>
              <div id="box">
                <p
                  v-for="(errorData, index) in getErrorDatas"
                  :key="index">
                  - Data {{ errorData.index }}: {{ errorData.message }}.
                </p>
              </div>
            </div>
          </div>
          <br>
          <b-button
            v-if="finish"
            id="progress-screen-finish"
            variant="success"
            @click="toggleIsVisible">
            Finish
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';

export default {
  name: 'JProgressScreen',
  props: {
    dataKirim: {
      type: Array,
      default: () => ([]),
    },
    propertyData: {
      type: String,
      default: '',
    },
    urlApi: {
      type: Array,
      default: () => ([]),
    },
    headers: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      numOfFailed: 0,
      numOfSuccess: 0,
      max: 0,
      retrievedData: [],
      isVisible: false,
      finish: false,
      data_kirim_id: [],
      progress: 0,
    };
  },
  computed: {
    getErrorDatas() {
      return this.retrievedData.filter((data, index) => {
        if (data.error === true) {
          const datas = data;
          datas.index = index + 1;
          if (datas.errors) {
            if (datas.errors.length > 0) {
              // eslint-disable-next-line
              let errorMessages = [];
              // eslint-disable-next-line
              data.errors.forEach(function(error){
                errorMessages.push(error.message);
              });
              datas.message = errorMessages.join(', ');
            }
          }
          return datas;
        }
        return '';
      });
    },
  },
  watch: {
    retrievedData() {
      this.progress += 1;
      this.numOfFailed = this.getErrorDatas.length;
      this.numOfSuccess = this.retrievedData.length - this.numOfFailed;
      if (this.progress < this.dataKirim.length) {
        this.accessApi();
      } else {
        this.finish = true;
      }
    },
  },
  methods: {
    toggleIsVisible() {
      this.isVisible = !this.isVisible;
      if (this.isVisible === true) {
        this.progress = 0;
        this.accessApi();
      } else {
        this.retrievedData = [];
        this.max = 0;
        this.$emit('finish');
      }
    },

    async accessApi() {
      this.finish = false;
      this.max = this.dataKirim.length;
      const token = Vue.ls.get('Token');
      if (this.propertyData !== '') {
        // eslint-disable-next-line
        this.$set(this.data_kirim_id, this.progress, { id_csv: this.dataKirim[this.progress][this.propertyData].id });

        // eslint-disable-next-line
      if (this.dataKirim[this.progress][this.propertyData].root_id === '0' || this.dataKirim[this.progress][this.propertyData].root_id === 0 || this.dataKirim[this.progress][this.propertyData].root_id === '') {
          this.$set(this.dataKirim[this.progress][this.propertyData], 'id', 0);
          this.$set(this.dataKirim[this.progress][this.propertyData], 'root_id', 0);
        } else {
          const rootIdCSV = this.dataKirim[this.progress][this.propertyData].root_id;
          // eslint-disable-next-line
          const rootId = this.data_kirim_id.filter(fildat => fildat.id_csv === rootIdCSV);
          this.$set(this.dataKirim[this.progress][this.propertyData], 'id', 0);
          this.$set(this.dataKirim[this.progress][this.propertyData], 'root_id', rootId[0].id_db);
        }
      } else {
        this.$set(this.data_kirim_id, this.progress, { id_csv: this.dataKirim[this.progress].id });

        // eslint-disable-next-line
        if (this.dataKirim[this.progress].root_id === '0' || this.dataKirim[this.progress].root_id === 0 || this.dataKirim[this.progress].root_id === '') {
          this.$set(this.dataKirim[this.progress], 'id', 0);
          this.$set(this.dataKirim[this.progress], 'root_id', 0);
        } else {
          const rootIdCSV = this.dataKirim[this.progress].root_id;
          // eslint-disable-next-line
          const rootId = this.data_kirim_id.filter(fildat => fildat.id_csv === rootIdCSV);
          this.$set(this.dataKirim[this.progress], 'id', 0);
          this.$set(this.dataKirim[this.progress], 'root_id', 0);
        }
      }
      await axios.post(this.urlApi[this.progress], this.dataKirim[this.progress], {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((response) => {
        const responses = response;
        this.retrievedData.push(responses.data);
        this.$set(this.data_kirim_id[this.progress], 'id_db', response.data.data.id);
      })
        .catch((error) => {
          // handle error
          this.retrievedData.push(error.response.data);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/progress-screen/jProgressScreen.vue